import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forget-password',

  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
})
export class ForgetPasswordComponent {
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
  }
}
